import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, message } from "antd";
import { useEffect } from "react";
import { useLoading } from "../../context/loadingContext";
import UpdateMerchant from "../../functions/admin/updateMerchant";
import BankCodeSelect from "../select/bankCodeSelect";
import { bg_button } from "constant/css";

const packOptions = [
  { value: "starter", label: "Starter" },
  { value: "growth", label: "Growth" },
  { value: "pro", label: "Pro" },
  { value: "business", label: "Business" },
];

const MerchantInfoEdit = ({ open, close, merchant, refresh }) => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    if (open && merchant) {
      form.setFieldsValue({
        name: merchant.name,
        email: merchant.email,
        register: merchant.register,
        phone: merchant.phone,
        phone2: merchant.phone2,
        address: merchant.address,
        pack: merchant.pack,
        accountNumber: merchant.accountNumber,
        bankCode: merchant.bankCode,
        feePercent: merchant.feePercent,
        spayFeePercent: merchant.spayFeePercent,
        userFee: merchant.userFee,
        userFeeType: merchant.userFeeType || "PERCENT",
      });
    }
  }, [open, merchant, form]);

  const handleSubmit = async (values) => {
    showLoading();
    const response = await UpdateMerchant(merchant.id, values);
    hideLoading();
    if (response?.success) {
      message.success("Амжилттай хадгалагдлаа");
      refresh();
      close();
    }
  };

  return (
    <Modal
      title="Мерчант мэдээлэл засах"
      open={open}
      onCancel={close}
      footer={null}
      width={720}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="mt-4"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Нэр"
              name="name"
              rules={[{ required: true, message: "Нэр оруулна уу" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Имэйл"
              name="email"
              rules={[
                { required: true, message: "Имэйл оруулна уу" },
                { type: "email", message: "Имэйл буруу байна" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Байгууллагын регистр" name="register">
              <Input maxLength={10} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Утас 1"
              name="phone"
              rules={[{ required: true, message: "Утас оруулна уу" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Утас 2" name="phone2">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Багц" name="pack">
              <Select options={packOptions} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Байршил" name="address">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Банк" name="bankCode">
              <BankCodeSelect />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Дансны дугаар" name="accountNumber">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Төлбөрийн шимтгэл (%)" name="feePercent">
              <InputNumber className="w-full" min={0} max={100} step={0.1} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="xPay шимтгэл (%)" name="spayFeePercent">
              <InputNumber className="w-full" min={0} max={100} step={0.1} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Хэрэглэгч шимтгэл" name="userFee">
              <InputNumber className="w-full" min={0} step={0.1} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Хэрэглэгч шимтгэлийн төрөл" name="userFeeType">
              <Select
                options={[
                  { value: "PERCENT", label: "Хувь (%)" },
                  { value: "FIXED", label: "Тогтмол (₮)" },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <div className="flex justify-end gap-2">
          <Button onClick={close}>Болих</Button>
          <Button type="primary" htmlType="submit" className={bg_button}>
            Хадгалах
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default MerchantInfoEdit;
